'use strict'

module.exports = () => {
  const promiseMap = new Map()

  return (func, queueKey) => {
    if (!promiseMap.has(queueKey)) {
      promiseMap.set(queueKey, Promise.resolve())
    }

    const promise = promiseMap
      .get(queueKey)
      .then(func)
      .catch(err => {
        promiseMap.delete(queueKey)

        return Promise.reject(err)
      })

    promiseMap.set(queueKey, promise)

    return promise
  }
}



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/async/queuedFunc.js